import { Component, inject } from '@angular/core';
import { FillHeightDirective } from '@static/directives/fill-height.directive';
import { AuthService } from '@static/services/auth.service';
import { HttpService } from '@static/services/http.service';
import { MarkdownComponent } from 'ngx-markdown';

@Component({
  selector: 'app-changelog',
  imports: [
    FillHeightDirective,
    MarkdownComponent,
  ],
  templateUrl: './changelog.component.html',
  styleUrl: './changelog.component.scss'
})
export class ChangelogComponent {
  private _http: HttpService = inject(HttpService);
  private _authService: AuthService = inject(AuthService);

  public data?: string;

  constructor() {
    this._http.getP<string>('/changelog.md', { responseType: 'text' })
      .then((data: string) => {
        this._processChangelog(data);
      });
  }

  /**
   * Extract the relevant versions from the changelog
   *
   * @param log changelog text
   */
  private _processChangelog(log: string): void {
    const lines = log.split(/\r?\n/);

    const displayParts: string[] = [];
    lines.forEach((line) => {
      if (line.includes("[GA]") && !this._authService.isGlobalAdmin) return;
      if (line.includes("[SA]") && !this._authService.isSiteAdmin) return;
      displayParts.push(line);
    });

    this.data = displayParts.join("\n");
  }
}
